import React from 'react';
import { FilledInput, FormControl, IconButton, InputAdornment, InputLabel } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import clsx from 'clsx';
export default function PasswordInput({
  showPassword,
  value,
  onChange,
  label,
  handleClickShowPassword,
  classes,
  name,
  ...rest
}) {
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <FormControl variant="filled">
      <InputLabel htmlFor={'filled-adornment-password' + name}>{label}</InputLabel>
      <FilledInput
        type={showPassword ? 'text' : 'password'}
        className={clsx(classes.root, classes.underline)}
        id={'filled-adornment-password' + name}
        name={name}
        {...rest}
        inputProps={{
          autocomplete: rest.autocomplete,
        }}
        value={value}
        onChange={onChange}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              style={{ position: 'absolute', right: 10, top: 0 }}
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
}

export * from './TogglePassword';
